import { Skeleton } from "antd";

export const InputSkeleton: React.FC = () => {
  return <Skeleton.Input className="w-full" active />;
};
